/* Calm Liquid — mega-menu: crossfade featured teas per hovered category.
   Delegated listeners so the behavior survives Horizon's background
   section re-render of the header. */
(function () {
  if (window.__clMenuInit) return;
  window.__clMenuInit = true;

  function reset(scope) {
    (scope || document).querySelectorAll('.cl-menu-set[data-cl-active]').forEach(function (s) {
      s.removeAttribute('data-cl-active');
      s.setAttribute('aria-hidden', 'true');
    });
  }

  function activate(anchor) {
    var submenu = anchor.closest('.menu-list__submenu');
    if (!submenu) return;
    var handle = anchor.getAttribute('data-cl-target');
    var found = false;
    submenu.querySelectorAll('.cl-menu-set').forEach(function (s) {
      if (s.getAttribute('data-cl-set') === handle) {
        s.setAttribute('data-cl-active', '');
        s.setAttribute('aria-hidden', 'false');
        found = true;
      } else {
        s.removeAttribute('data-cl-active');
        s.setAttribute('aria-hidden', 'true');
      }
    });
    if (!found) reset(submenu);
  }

  function fromEvent(e) {
    return e.target && e.target.closest ? e.target.closest('a[data-cl-target]') : null;
  }

  document.addEventListener('pointerover', function (e) {
    var a = fromEvent(e);
    if (a) activate(a);
  });

  document.addEventListener('focusin', function (e) {
    var a = fromEvent(e);
    if (a) activate(a);
  });

  /* Leaving the whole submenu resets to the default set (while hidden). */
  document.addEventListener(
    'pointerout',
    function (e) {
      var sub = e.target && e.target.closest ? e.target.closest('.menu-list__submenu') : null;
      if (sub && !(e.relatedTarget && sub.contains(e.relatedTarget))) reset(sub);
    },
    true
  );
})();
